import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "menu_application",
  "use": "menu_application-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"menu_application\">\r\n    <path d=\"M18.3334 16.6667V5.83333L16.6667 2.5H3.33335L1.66669 5.83627V16.6667C1.66669 17.1269 2.03979 17.5 2.50002 17.5H17.5C17.9603 17.5 18.3334 17.1269 18.3334 16.6667ZM3.33335 7.5H16.6667V15.8333H3.33335V7.5ZM4.36335 4.16667H15.6367L16.47 5.83333H3.53085L4.36335 4.16667ZM12.5 9.16667H7.50002V10.8333H12.5V9.16667Z\" fill=\"currentColor\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol